import { Company, EmbeddedCompany } from 'types';
import { ModelScene, CreateScene, EntityScene, UpdateScene, DeleteScene, IndexScene } from 'components';
import { Form } from './Form';
import { RouteObject } from 'react-router';
import { Link } from 'react-router-dom';
import permissions from 'modules/core/company/permissions';
import initialValues from './initialValues';
import { FromTicket } from './FromTicket';
import { ListImport, ListExport } from 'components/ListActions';
import { ControlledTableColumns } from 'components/ControlledTable';

export const baseColumns: ControlledTableColumns<EmbeddedCompany> = [
  {
    content: 'Title',
    key: 'title',
    required: true,
    sortable: true,
    render: ({ id, title }) => <Link to={`${id}`}>{title || <em>Title</em>}</Link>,
  },
  {
    content: 'Internal name',
    sortable: true,
    key: 'internal_name',
  },
  { content: 'Code', key: 'code', sortable: true, width: 80 },
  { content: 'Kind', key: 'kind', sortable: true, width: 90 },
  { content: 'Registration number', sortable: true, key: 'registration_number', width: 200 },
];

const model = {
  endpoint: 'core/companies/',
  title: 'Company',
  pluralTitle: 'Companies',
  entityTitle: ({ title }: Company) => title,
  permissions,
};

export const route: RouteObject = {
  path: 'companies',
  element: <ModelScene {...model} />,
  children: [
    {
      index: true,
      element: (
        <IndexScene
          columns={baseColumns}
          toolbar={
            <>
              <ListImport permission={permissions.import} />
              <ListExport permission={permissions.export} />
            </>
          }
        />
      ),
    },
    {
      path: 'create',
      element: (
        <CreateScene initialValues={initialValues}>
          <Form />
        </CreateScene>
      ),
    },
    {
      path: 'from_ticket/:id',
      element: <FromTicket />,
    },
    {
      path: ':id/',
      element: <EntityScene />,
      children: [
        {
          index: true,
          element: (
            <UpdateScene viewDisabled>
              <Form />
            </UpdateScene>
          ),
        },
        {
          path: 'delete',
          element: <DeleteScene />,
        },
      ],
    },
  ],
};
